<app-input-wrapper
  [id]="id ? id + '-wrapper' : undefined"
  [titleLabel]="titleLabel"
  [infoLabel]="infoLabel"
>
  <div class="date-range-container">
    <mat-form-field appearance="outline" (click)="pickerStart.open()">
      <input matInput
        [attr.id]="id ? id + '-start' : null"
        [matDatepicker]="pickerStart"
        [formControl]="startControl"
        placeholder="Fecha inicial"
        i18n-placeholder="@@startDateLabel"
        [min]="computedMinStart"
        [max]="computedMaxStart"
        readonly
      >
      <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
      <mat-datepicker #pickerStart
        [panelClass]="mode === 'monthYear' ? 'hide-period-button' : ''"
        [startView]="mode === 'monthYear' ? 'year' : 'month'"
        [startAt]="startAt"
        (monthSelected)="monthSelected($event, pickerStart, startControl)"
      >
      </mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" (click)="pickerEnd.open()">
      <input matInput
        [attr.id]="id ? id + '-end' : null"
        [matDatepicker]="pickerEnd"
        [formControl]="endControl"
        placeholder="Fecha final"
        i18n-placeholder="@@endDateLabel"
        [min]="computedMinEnd"
        [max]="computedMaxEnd"
        readonly
      >
      <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd
        [panelClass]="mode === 'monthYear' ? 'hide-period-button' : ''"
        [startView]="mode === 'monthYear' ? 'year' : 'month'"
        [startAt]="endAt"
        (monthSelected)="monthSelected($event, pickerEnd, endControl)"
      >
      </mat-datepicker>
    </mat-form-field>
  </div>
</app-input-wrapper>
